// @flow
import { createReducer, createActions } from 'reduxsauce'
import Immutable from 'seamless-immutable'

/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
  attractionPromoRequest: ['data'],
  attractionPromoSuccess: ['data'],
  attractionPromoFailure: ['err'],

  postAttractionPromoRequest: ['data'],
  postAttractionPromoSuccess: ['data'],
  postAttractionPromoFailure: ['err'],

  putAttractionPromoRequest: ['data'],
  putAttractionPromoSuccess: ['data'],
  putAttractionPromoFailure: ['err'],

  deleteAttractionPromoRequest: ['data'],
  deleteAttractionPromoSuccess: ['data'],
  deleteAttractionPromoFailure: ['err']
})

export const AttractionPromoTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
  fetching: false,
  processing: false,
  data: [],
  err: null,
  success: false
})

/* ------------- Reducers ------------- */

export const request = (state: Object) =>
  state.merge({ fetching: true, success: false })

export const success = (state: Object, { data }: Object) =>
  state.merge({
    fetching: false,
    processing: false,
    data,
    err: null
  })

export const failure = (state: Object, { err }: Object) =>
  state.merge({ fetching: false, err })

export const manipulateRequest = (state: Object) => state.merge({ processing: true, success: null })

export const manipulateSuccess = (state: Object, { data }: Object) =>
  state.merge({
    processing: false,
    success: true,
    err: null
  })

export const manipulateFailure = (state: Object, { err }: Object) =>
  state.merge({ processing: false, err, success: null })

/* ------------- Hookup Reducers To Types ------------- */

export const reducer = createReducer(INITIAL_STATE, {
  [Types.ATTRACTION_PROMO_REQUEST]: request,
  [Types.ATTRACTION_PROMO_SUCCESS]: success,
  [Types.ATTRACTION_PROMO_FAILURE]: failure,

  [Types.POST_ATTRACTION_PROMO_REQUEST]: manipulateRequest,
  [Types.POST_ATTRACTION_PROMO_SUCCESS]: manipulateSuccess,
  [Types.POST_ATTRACTION_PROMO_FAILURE]: manipulateFailure,

  [Types.PUT_ATTRACTION_PROMO_REQUEST]: manipulateRequest,
  [Types.PUT_ATTRACTION_PROMO_SUCCESS]: manipulateSuccess,
  [Types.PUT_ATTRACTION_PROMO_FAILURE]: manipulateFailure,

  [Types.DELETE_ATTRACTION_PROMO_REQUEST]: manipulateRequest,
  [Types.DELETE_ATTRACTION_PROMO_SUCCESS]: manipulateSuccess,
  [Types.DELETE_ATTRACTION_PROMO_FAILURE]: manipulateFailure
})



// WEBPACK FOOTER //
// ./src/Redux/AttractionPromoRedux.js